export const DEFAULT_PRICE = 0;
